<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadcrumbs"
                   class="px-1 py-2">
    </v-breadcrumbs>
    <p class="text-center"
       v-if="loading">
      <v-progress-circular indeterminate>
      </v-progress-circular>
    </p>
    <template v-if="!loading && contact">
      <v-card class="mb-4 pa-4">
        <h1 class="text-h4">
          <v-avatar color="accent"
                    size="40">
          <span class="white--text text-h5">
            {{ contact.initials }}
          </span>
          </v-avatar>
          {{ contact.name ? contact.name : contact.email }}
        </h1>
      </v-card>
      <v-row>

        <v-col cols="12"
               sm="4">
          <v-card class="mb-4">
            <v-card-title class="text-h5">
              Details
              <v-spacer></v-spacer>
              <v-btn>
                Edit
              </v-btn>
            </v-card-title>

            <v-card-text class="pb-4">
              <v-row no-gutters>
                <v-col cols="5">
                  Email Address
                </v-col>
                <v-col cols="7">
                  {{ contact.email }}
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="5">
                  Greeting Type
                </v-col>
                <v-col cols="7">
                  {{ contact.greeting_type }}
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="5">
                  Salutation
                </v-col>
                <v-col cols="7">
                  {{ contact.salutation }}
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="5">
                  First Name
                </v-col>
                <v-col cols="7">
                  {{ contact.first_name }}
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="5">
                  Last Name
                </v-col>
                <v-col cols="7">
                  {{ contact.last_name }}
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="5">
                  Company
                </v-col>
                <v-col cols="7">
                  {{ contact.company_name }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mb-4">
            <v-card-title class="text-h5">
              CRM Information
            </v-card-title>
            <v-card-text class="pb-4">
              <v-row no-gutters>
                <v-col cols="4">
                  CRM Provider
                </v-col>
                <v-col cols="8"
                       class="text-uppercase">
                  {{ contact.crm_provider }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="4">
                  CRM Object
                </v-col>
                <v-col cols="8">
                  {{ contact.crm_object }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="4">
                  CRM ID
                </v-col>
                <v-col cols="8">
                  {{ contact.crm_object_id }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12"
               sm="8">

          <v-card class="mb-4">
            <v-card-title class="text-h5">
              Engagement Timeline
            </v-card-title>
          </v-card>

          <v-timeline v-if="contact && events.length > 0"
                      :dense="$vuetify.breakpoint.mdAndDown">
            <v-timeline-item v-for="event in orderedEvents"
                             :key="event.id"
                             :color="event.color"
                             :icon="event.icon"
                             fill-dot
                             large>
              <template v-slot:opposite>
                <div>
                  {{ event.event_at | datetime('MMMM D, YYYY') }}
                </div>
                <div>
                  {{ event.event_at | datetime('h:mm a') }}
                </div>
              </template>
              <v-card :color="event.color"
                      dark>
                <v-card-title class="text-h6 py-2">
                  {{ event.title }}
                </v-card-title>
                <v-card-text class="white text--primary pa-4">
                  <div>
                    {{ event.body }}
                  </div>
                  <div v-if="$vuetify.breakpoint.mdAndDown">
                    {{ event.event_at | datetime('MMMM D, YYYY h:mm a') }}
                  </div>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>
<script>
import {orderBy} from 'lodash';
import userContactService from '../../services/userContactService';

const fakeEvents = [
  {
    id: 1,
    event_type: 'device_session',
    event_at: 'December 15, 2023 at 3:35 pm',
    color: 'green lighten-1',
    icon: 'fal fa-presentation',
    title: 'In-Person Presentation',
    body: 'Mark Stralka presented "ABC Core Visual Aid" for 7 minutes 15 seconds.',
    user: 'Mark Stralka',
    presentation: 'ABC Core Visual Aid',
    data: {
      user_id: 3,
      device_session_id: 11111,
    }
  },

  {
    id: 2,
    event_type: 'message',
    event_at: 'January 1, 2024 at 9:33 pm',
    color: 'red lighten-2',
    icon: 'fal fa-paper-plane',
    title: 'Email sent',
    body: `Mark Stralka sent email "Thank you for meeting with me".`,
    user: 'Mark Stralka',
    email_template: 'Simple Follow-up Email Template',
    data: {
      user_id: 3,
      message_id: 11111,
    }
  },
  {
    id: 3,
    event_type: 'shared_link_hit',
    event_at: 'January 2, 2024 at 12:01 pm',
    color: 'amber darken-1',
    icon: 'fal fa-hand-pointer',
    title: 'Clicked a link in an email',
    body: 'Jack Smith clicked a link in an email',
    user: 'Mark Stralka',
    email_template: 'Simple Follow-up Email Template',
    data: {
      session_id: 11111,
    }
  },
  {
    id: 4,
    event_type: 'session',
    event_at: 'January 2, 2024 at 12:01 pm',
    color: 'purple darken-1',
    icon: 'fal fa-eye',
    title: 'Viewed File',
    body: 'Jack Smith viewed "5 Things You Never Do at a Trade Show" for 5 minutes 32 seconds.',
    data: {
      session_id: 11111,
    }
  },
];

export default {
  data() {
    return {
      contact: null,
      loading: false,
      events: [],
    }
  },
  computed: {
    orderedEvents() {
      return orderBy(this.events, ['event_at'], ['desc']);
    },
    breadcrumbs() {
      return [
        {
          exact: true,
          text: 'Contacts',
          to: {name: `${this.$root.routePrefix}.user_contacts.index`},
        },
        {
          text: 'Contact',
        }
      ];
    },
    contactID() {
      return parseInt(this.$route.params.contactID);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      userContactService.getContact(this.contactID)
        .then(data => {
          this.contact = data;
        })
        .finally(() => {
          this.loading = false;
        });

      userContactService.getEventsFor(this.contactID)
        .then(data => {
          this.events = data;
        })
    }
  }
}
</script>
